function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBridge = function SvgBridge(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.488 5.734",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-10.861 99.461h1.932v2.056h-1.932z",
    style: {
      fill: "none",
      stroke: "#b8bec9",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(14.167 -96.033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-11.984 98.338 1.123 1.123",
    style: {
      fill: "#b8bec9",
      fillOpacity: 1,
      stroke: "#b8bec9",
      strokeWidth: ".26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(14.167 -96.033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.984-98.338h1.932v2.056h-1.932z",
    style: {
      fill: "none",
      stroke: "#b8bec9",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(180 7.083 -48.016)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBridge);
export { ForwardRef as Icon };
export default "img/feather-customised/bridge.8ca4493.svg";